var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TerminalPreview',{scopedSlots:_vm._u([{key:"terminal-content",fn:function(){return [_c('div',{ref:"player-container",staticClass:"asciiPlayer-terminal"})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }